<script>
import bus from 'vue3-eventbus'
export default {
  props: {
    tips: String,
    earn: String
  },
  data () {
    return {
      userData: {},
    }
  },
  computed: {
    levels () {
      console.log(this.$store.state.appConfig)
      return this.$store.state.appConfig.level ? this.$store.state.appConfig.level : []
    }
  },
  methods: {
    dissmiss () {
      bus.emit('dismissNoticeTips')
    },
    nomal () {
    }
  },
  mounted () {
    const user = this.$store.state.user
    if (user) {
      this.userData = user
    }
  },
}
</script>
<template>
  <div class="root">
    <img src="@/assets/iv_notice_title.png">
    <p v-if="earn" class="amount">{{ earn }}</p>
    <p v-if="earn" class="content">{{ tips }}</p>
    <p v-if="!earn" class="content-main">{{ tips }}</p>


    <div style="display: flex; flex-direction: row; align-self: center; margin-top: auto;">
      <p class="negative"  @click="dissmiss">GOT IT</p>
    </div>

  </div>
</template>

<style scoped>


.level-img {
  position: absolute;
  height: 27rem;
  width: 27rem;  
  background-size: cover;
  background-repeat: no-repeat;
  align-self: center;
  margin-top: 10rem;
}

.level-rate {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-items: center;
  align-self: center;
  margin-top: 2rem;
}

.positive {
  color: white;
  font-size: 2.8rem;
  width: 27.1rem;
  height: 8.6rem;
  text-align: center;
  font-weight: 400;
  line-height: 6rem;
  background-image: url("@/assets/bg_logout_confirm.png");
  background-size: cover;
  justify-content: center;
  align-content: center;
}

.positive:active {
  opacity: 0.6;
}

.negative {
  color: white;
  font-size: 2.8rem;
  width: 27.1rem;
  height: 8.6rem;
  text-align: center;
  line-height: 6rem;
  font-weight: 600;
  background-image: url("@/assets/bg_logout_cancel.png");
  background-size: cover;
  justify-content: center;
  align-content: center;
}

.negative:active {
  opacity: 0.6;
}

.level-bg {
  width: 47rem;
  height: 24.8rem;
  background-image: url("@/assets/bg_level_rule_light.png");
  background-size: cover;
  background-repeat: no-repeat;
  pointer-events: none;
  align-self: center;
}

.level-txt {
  width: 24.2rem;
  height: 5.8rem;
  line-height: 5rem;
  font-size: 2.8rem;
  text-align: center;
  background-image: url("@/assets/diamond_txt_bg.png");
  background-size: 100% 100%;
  color: white;
  font-weight: bolder;
  z-index: 0;
  margin-top: -6rem;
  align-self: center;
}

.root {
  width: 64.4rem;
  height: 53.1rem;
  background-image: url("@/assets/bg_notice_dialog.png");
  background-size: 100% 95%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-self: center;
  justify-self: center;
}

.root > img {
  width: 28.3rem;
  height: 10.5rem;
  align-self: center;
}

.amount {
  width: auto;
  margin-top: 8rem;
  color: #FFFAC4;
  font-size: 6.4rem;
  align-content: center;
  justify-content: center;
  align-self: center;
  justify-self: center;
  font-weight: 800;
  font-style: italic;
}

.content {
  width: auto;
  height: auto;
  color: #CCC0FF;
  font-size: 2.2rem;
  align-content: center;
  justify-content: center;
  align-self: center;
  justify-self: center;
  line-height: 1.5;
  overflow-wrap: break-word;
  margin-top: 1rem;
}

.content-main {
  width: 28rem;
  height: 100%;
  color: #CCC0FF;
  font-size: 2.2rem;
  align-content: center;
  justify-content: center;
  align-self: center;
  justify-self: center;
  line-height: 1.5;
  overflow-wrap: break-word;
}

.root > img:active {
  opacity: 0.6;
}



.no-border-right {
  border-right: 0 solid transparent;
}

.img-contain {
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.img-cell {
  background-size: cover;
}

.cell-bg {
  background-color: #F3B25633;
}
</style>
